import { PipeTransform, Pipe } from '@angular/core';
import { LocalizationService } from '@services/localization.service';
type langConfig = {
  [key: string]: {
    locales: string;
    currency: string;
  };
};
@Pipe({ name: 'balanceFormat' })
export class BalanceFormatPipe implements PipeTransform {
  constructor(private _LocalizationService: LocalizationService) {}

  langConfig: langConfig = {
    en: {
      locales: 'en-US',
      currency: 'USD',
    },
    de: {
      locales: 'de-DE',
      currency: 'EUR',
    },
    tr: {
      locales: 'tr-TR',
      currency: 'TRY',
    },
    fa: {
      locales: 'fa-IR',
      currency: 'IRR',
    },
  };

  formatCurrency(amount, lang) {
    // varsayılan olarak 'de' koyuldu ihtiyaç duyulursa fonksiyona lang değeri gönderilebilir.
    let balance: number;
    if (isNaN(amount)) {
      balance = parseFloat(amount);
    } else {
      balance = amount;
    }
    const langCode = this.langConfig[lang ? lang : this._LocalizationService.LANGCODE];
    return new Intl.NumberFormat(langCode.locales, { style: 'currency', currency: langCode.currency }).format(balance);
  }

  transform(value, lang?: string): any {
    if (value) {
      return this.formatCurrency(value, 'de');
    } else return value;
  }
}

@Pipe({ name: 'cashoutBalance' })
export class CashoutBalance implements PipeTransform {
  transform(value): any {
    if (typeof value === 'string') {
      return parseFloat(value);
    } else return value;
  }
}
